import { IStyleableProps } from "lib/interfaces/IStyleableProps";
import { Padding } from "lib/styles/Padding";
import * as React from "react";

interface IContainerProps extends IStyleableProps {
  fluid?: boolean;
  centered?: boolean;
  padding?: Padding;
}

/**
 * Wrapper for div.row
 *
 * @param props Props for component
 */
export const Container = (props: IContainerProps) => {
  const { fluid, className, padding, centered } = props;
  let finalClassName = "container";

  if (fluid) {
    finalClassName += "-fluid";
  }
  if (className) {
    finalClassName += " " + className;
  }
  if (centered) {
    finalClassName +=
      " absolute-center w-100 justify-content-center d-flex";
  }
  if (!padding) {
    finalClassName += " " + Padding.none;
  } else {
    finalClassName += " " + padding;
  }

  return <div className={finalClassName}>{props.children}</div>;
};



// WEBPACK FOOTER //
// ./src/components/common/container/Container.tsx